export function validCellphone(cellphone: string): boolean {
  const pattern = /^\(?([0-9]{2})\)?\s?9([0-9]{4})-?([0-9]{4})$/;
  if (!cellphone) {
    return false;
  }
  return pattern.test(cellphone);
}
